import { redirect } from "next/navigation";
import { ApiError } from "./api-client";

/**
 * Global API error handler for server-side calls.
 * - 401 -> redirect to sign-in (clears stale sessions)
 * - otherwise rethrow
 */
export function handleApiError(error: unknown): never {
  if (error instanceof ApiError && error.status === 401) {
    redirect("/sign-in?reason=unauthorized");
  }

  if (error instanceof Error && error.message === "Authentication required") {
    redirect("/sign-in?reason=unauthorized");
  }

  throw error;
}
